export enum DataType{
    TextType = "TextType",
    NumberType = "NumberType",
}